var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExternalLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_external_link",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M.63,8.169a.625.625,0,0,1-.446-.185.636.636,0,0,1,0-.893L7.091.183a.631.631,0,0,1,.893.893L1.076,7.984A.625.625,0,0,1,.63,8.169Z",
    transform: "translate(7.803 4.03)",
    fill: "#dc4404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.675,5.307a.636.636,0,0,1-.632-.632V1.264H.632A.636.636,0,0,1,0,.632.636.636,0,0,1,.632,0H4.675a.636.636,0,0,1,.632.632V4.675A.636.636,0,0,1,4.675,5.307Z",
    transform: "translate(11.339 3.354)",
    fill: "#dc4404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M8.5,13.292H4.791C1.434,13.292,0,11.858,0,8.5V4.791C0,1.434,1.434,0,4.791,0l.687.014a.467.467,0,0,1,.464.464.467.467,0,0,1-.464.464L4.791.927C1.941.927.927,1.941.927,4.791V8.5c0,2.85,1.014,3.864,3.864,3.864H8.5c2.85,0,3.864-1.014,3.864-3.864V7.822a.464.464,0,1,1,.927,0V8.5C13.292,11.858,11.858,13.292,8.5,13.292Z",
    transform: "translate(3.354 3.354)",
    fill: "#dc4404",
    stroke: "#dc4404",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExternalLink);
export default __webpack_public_path__ + "static/media/ic_external_link.95ff39f9d5c0ad0121d268528790ba69.svg";
export { ForwardRef as ReactComponent };